/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRectangleVertical = createReactComponent(
  "rectangle-vertical",
  "IconRectangleVertical",
  [
    [
      "path",
      {
        d: "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z",
        key: "svg-0"
      }
    ]
  ]
);

export { IconRectangleVertical as default };
//# sourceMappingURL=IconRectangleVertical.js.map
